// UPDATED ProjectTiles.jsx

import React, { useEffect } from "react";
import ApexCharts from "apexcharts";
import useDashboardStore from "../../../store/builders/useDashboardStore";
import useProjectStatus from "../../../store/builders/useProjectStatus";
import { useNavigate } from "react-router-dom";

const ProjectTile = ({ number, title, icon, chartId, chartColor, lineWidth }) => {
  const { chartData, getChartData } = useDashboardStore();
  const navigate = useNavigate();

  const handleclick = () => {
    const t = title.trim().toLowerCase();
    if (t.includes("live")) navigate("/builder/liveproject");
    else if (t.includes("hold")) navigate("/builder/holdproject");
    else if (t.includes("completed")) navigate("/builder/completedproject");
  };

  useEffect(() => {
    getChartData();
  }, [getChartData]);

  useEffect(() => {
    if (!chartData || !chartData.labels || !chartData.datasets) return;

    let datasetName = title.replace(" projects", " Projects");

    const selectedDataset = chartData.datasets.find(
      (dataset) => dataset.name === datasetName
    );
    if (!selectedDataset) return;

    const options = {
      chart: {
        height: 60,
        width: 80,
        type: "area",
        toolbar: { show: false },
      },
      dataLabels: { enabled: false },
      stroke: { width: lineWidth, colors: [chartColor] },
      series: [
        {
          name: title,
          data: selectedDataset.data.slice(-6),
        },
      ],
      xaxis: { labels: { show: false } },
      yaxis: { show: false },
      grid: { show: false },
      fill: {
        type: "gradient",
        gradient: {
          opacityFrom: 0.45,
          opacityTo: 0,
        },
      },
    };

    const chart = new ApexCharts(document.querySelector(`#${chartId}`), options);
    chart.render();

    return () => chart.destroy();
  }, [chartId, chartColor, lineWidth, chartData, title]);

  return (
    <div
      onClick={handleclick}
      className="bg-white h-24 sm:h-28 w-full rounded-xl p-3 flex flex-col justify-between relative cursor-pointer shadow"
    >
      <div>
        <p className="text-lg sm:text-xl font-bold">{number}</p>
        <p className="text-xs text-gray-600 font-semibold">{title}</p>
      </div>

      <img src={icon} alt="" className="h-6 w-6 absolute left-3 bottom-3" />

      <div id={chartId} className="absolute right-2 bottom-2"></div>
    </div>
  );
};

const ProjectTiles = () => {
  const { projectTile, getProjectTile } = useDashboardStore();
  const { fetchProjects, getTotalCompletedBudget } = useProjectStatus();

  useEffect(() => {
    getProjectTile();
    fetchProjects("completed");
  }, [getProjectTile, fetchProjects]);

  const totalCompletedBudget = getTotalCompletedBudget();

  const tilesData = [
    {
      number: projectTile?.live_projects || 0,
      title: "Live projects",
      icon: "/protile/engineer_10727828.png",
      chartId: "chart-1",
      chartColor: "#2FB2AB",
      lineWidth: 1,
    },
    {
      number: projectTile?.pending_projects || 0,
      title: "Hold Project",
      icon: "/protile/onboarding_16751381.png",
      chartId: "chart-2",
      chartColor: "#27CFA7",
      lineWidth: 1,
    },
    {
      number: projectTile?.completed_projects || 0,
      title: "Completed projects",
      icon: "/protile/folder_11171774.png",
      chartId: "chart-3",
      chartColor: "#6142FF",
      lineWidth: 1,
    },

    /** 🔥 TOTAL COMPLETED BUDGET TILE */
    {
      number: `₹${totalCompletedBudget.toLocaleString("en-IN")}`,
      title: "Completed Project Budget",
      icon: "/protile/questionnaire_11275251.png",
      chartId: "chart-4",
      chartColor: "#FA902F",
      lineWidth: 1,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
      {tilesData.map((tile, i) => (
        <ProjectTile key={i} {...tile} />
      ))}
    </div>
  );
};

export default ProjectTiles;
